import albumService from '../../services/albumService'
import Vue from "vue";
import {distinctById} from "../../utils";

const state = {
    albums: [],
    move_albums: [],
    loading: true,
    add_loading: false,
    next_page: 1,
    need_pay: 0,
    opened_album_id: null,
};

const getters = {
    detail_album: state => {
        return state.albums.find(obj => obj.id === parseInt(state.opened_album_id))
    }
}

const actions = {
    getTotalAlbum({commit}, album_id) {
        return new Promise((resolve, reject) => {
            albumService.totalAlbum(album_id)
                .then(data => {
                    resolve();
                    commit('setTotalAlbum', {album_id, total: data})
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить итоги альбома.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getDeliveryInfos(store, params) {
        return new Promise((resolve, reject) => {
            albumService.getDeliveryInfos(params)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить ранее добавленную информацию по доставке.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getMoveAlbums({commit}, params) {
        return new Promise((resolve, reject) => {
            albumService.fetchMoveAlbums(params)
                .then(data => {
                    resolve();
                    commit('setMoveAlbums', data)
                })
                .catch((error) => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список альбомов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getAlbums({commit}, params) {
        return new Promise((resolve, reject) => {
            state.loading = state.next_page === 1;
            params['page'] = state.next_page;
            albumService.fetchAlbums(params)
                .then(data => {
                    let albums = state.albums.concat(data.results);
                    albums = distinctById(albums)
                    commit('setAlbums', {next: data.next, albums});
                    commit('clients/setOpenedClient', data.client, {root: true});
                    commit('setNeedPay', data.need_pay);
                    state.loading = false;
                    resolve();
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список альбомов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    state.loading = false;
                    reject();
                })
        });
    },
    getAlbum({commit, state}, album_id) {
        state.loading = true;
        return new Promise((resolve, reject) => {
            // const index = state.albums.findIndex(obj => obj.id === parseInt(album_id))
            // if (index !== -1) {
            //     resolve();
            //     state.loading = false;
            //     return
            // }
            albumService.getAlbumDetail(album_id)
                .then(data => {
                    commit('setAlbum', data.album);
                    commit('clients/setOpenedClient', data.client, {root: true});
                    state.loading = false;
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию об альбоме.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.loading = false;
                    reject();
                })
        })
    },
    addAlbum({commit, state}, data) {
        return new Promise((resolve, reject) => {
            if (data.title === '') {
                reject();
            }
            state.add_loading = true;
            albumService.postAlbum(data)
                .then(album => {
                    commit('addAlbum', album);
                    state.add_loading = false;
                    resolve();
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить альбом.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    state.add_loading = false;
                    reject();
                })
        })
    },
    editAlbum({commit}, {data}) {
        return new Promise((resolve, reject) => {
            if (data.title === '') {
                reject();
            }
            albumService.editAlbum(data)
                .then(album => {
                    resolve();
                    commit('updateAlbum', album);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отредактировать информацию об альбоме.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    deleteAlbum({commit}, {album_id}) {
        return new Promise((resolve, reject) => {
            albumService.deleteAlbum(album_id)
                .then(() => {
                    resolve();
                    commit('deleteAlbum', album_id)
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить альбом.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                });
        })
    },
    sendToPurchase({commit}, data) {
        return new Promise((resolve, reject) => {
            albumService.sendToPurchase(data)
                .then(data => {
                    resolve();
                    commit('updateAlbum', data);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отправить альбом в закупку.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
};

const mutations = {
    setOpenedAlbum(state, album_id) {
        state.opened_album_id = album_id;
    },
    setTotalAlbum(state, {album_id, total}) {
        let album = state.albums.find(obj => obj.id === album_id);
        if (album !== undefined) {
            Vue.set(album, 'total', total);
        }
    },
    setAlbums(state, {next, albums}) {
        if (next) {
            state.next_page += 1;
        } else {
            state.next_page = null;
        }
        state.albums = albums
    },
    setMoveAlbums(state, albums) {
        state.move_albums = albums
    },
    setAlbum(state, album) {
        const index = state.albums.findIndex(obj => obj.id === album.id)
        if (index === -1) {
            state.albums.push(album);
        } else {
            Vue.set(state.albums, index, album);
        }
    },
    addAlbum(state, album) {
        if (state.albums.findIndex(obj => obj.id === album.id) === -1) {
            state.albums.unshift(album)
        }
    },
    replaceAlbum(state, {album, index}) {
        Vue.set(state.albums, index, album);
    },
    deleteAlbum(state, album_id) {
        state.albums = state.albums.filter(obj => obj.id !== album_id)
    },
    updateAlbum(state, album) {
        const index = state.albums.findIndex(obj => obj.id === album.id);
        if (index !== -1) {
            if (state.albums[index].total !== undefined) {
                album.total = state.albums[index].total
            }
            Vue.set(state.albums, index, album);
        }
    },
    setNeedPay(state, value) {
        state.need_pay = value;
    },
    clearData(state) {
        state.next_page = 1;
        state.albums = []
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}